import React from "react";
import Chip from '@mui/material/Chip';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Gallery, { GalleryPhoto } from './Gallery';
import eagle from '../assets/images/eagle.jpg';
import flowers from '../assets/images/flowers.jpg';
import neon from '../assets/images/neon.jpg';
import pinball from '../assets/images/pinball.jpg';
import spaceNeedle from '../assets/images/spaceNeedle.jpg';
import woodwork from '../assets/images/woodWork.jpg';
import pineapple from '../assets/images/pineapple.jpg';
import beach from '../assets/images/beach.jpg';
import ferry from '../assets/images/ferry.jpg';
import flamingo from '../assets/images/flamingo.jpg';
import goldfish from '../assets/images/gold_fish.jpg';
import hummingbird from '../assets/images/hummingbird.jpg';
import moon from '../assets/images/moon.jpg';
import sunset from '../assets/images/sunset.jpg';
import '../assets/styles/Project.scss';

const hobbiesPhotos: GalleryPhoto[] = [
    { src: eagle, alt: 'Eagle in flight' },
    { src: flowers, alt: 'Flower photography' },
    { src: neon, alt: 'Neon lights' },
    { src: pinball, alt: 'Pinball machine' },
    { src: spaceNeedle, alt: 'Seattle Space Needle' },
    { src: woodwork, alt: 'Woodworking project' },
    { src: pineapple, alt: 'Pineapple blooming' },
    { src: beach, alt: 'Rocky Beach' },
    { src: ferry, alt: 'Ferry crossing' },
    { src: flamingo, alt: 'Flamingo' },
    { src: goldfish, alt: 'Goldfish' },
    { src: hummingbird, alt: 'Hummingbird' },
    { src: moon, alt: 'Moon' },
    { src: sunset, alt: 'Sunset' },
];

const addascoreTech = [
    "React", "TypeScript", "Vite",
    "Hono (Edge API)", "Cloudflare Workers",
    "Cloudflare Pages", "Cloudflare D1 (SQLite)",
    "Cloudflare KV", "Cloudflare R2",
    "Clerk Auth", "JWT / RS256",
    "PWA", "REST API"
];

function Project() {
    return (
        <>
            <div className="projects-container" id="projects">
                <h1>Personal Projects</h1>
                <div className="project-card-featured">
                    <a href="https://addascore.com" target="_blank" rel="noreferrer">
                        <img
                            src={process.env.PUBLIC_URL + '/og-image.png'}
                            alt="AddaScore — Pinball Leaderboard & Score Tracker"
                            className="project-card-image"
                        />
                    </a>
                    <div className="project-card-body">
                        <div className="project-card-header">
                            <h2>AddaScore</h2>
                            <a
                                href="https://addascore.com"
                                target="_blank"
                                rel="noreferrer"
                                className="project-live-link"
                            >
                                addascore.com <OpenInNewIcon fontSize="inherit" />
                            </a>
                        </div>
                        <p>A mobile-first PWA for logging pinball scores and competing on live leaderboards by game and venue. Designed and built solo on Cloudflare's edge infrastructure — Workers, D1, KV, R2, and Pages.</p>
                        <div className="flex-chips project-chips">
                            {addascoreTech.map((label, index) => (
                                <Chip key={index} className="chip" label={label} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="projects-container" id="about">
                <h1>About Me</h1>
                <p>
                    I grew up in Sabina, Ohio — a small farming village in the southwest corner of the state. I played football from grade school through high school, earning All-State honors two years in a row. That experience shaped how I work: hard work, discipline, and trusting the people around you are the foundation of anything worth building — whether on a field or in a codebase.
                </p>
                <p>
                    I attended Ohio University in Athens and graduated in 2011 with a B.S. in Computer Science. I started my career at G2O (formerly ICC) in Columbus in 2012 and relocated to Seattle, Washington in 2016, where I've been living and working remotely ever since.
                </p>
                <p>
                    Outside of work, I'm a hobby photographer, woodworker, and avid pinball player — I compete in local leagues and tournaments, which directly inspired building AddaScore. I also enjoy mountain biking, gardening, and tinkering with home automation systems on Home Assistant and Raspberry Pi.
                </p>

                <Gallery photos={hobbiesPhotos} />
            </div>
        </>
    );
}

export default Project;
